import get from 'lodash/get';

import LaunchDarkly from '@module/launchdarkly';

import Config from '@app/config';

const configure = () => {
  const user = get(window, '__feature_flags__.user', {});
  const bootstrap = get(
    window,
    '__launch_darkly__.feature_flags',
    'localStorage'
  );
  LaunchDarkly.configure({
    clientID: Config.launchDarkly.clientID,
    enabled: Config.launchDarkly.enabled,
    bootstrap,
    user,
  });
};

configure();

const init = () => LaunchDarkly.boot();

if (Config.launchDarkly.enabled === true) {
  init();
}

export { configure };
export default init;
